import { usePurchaseStore } from '../stores/purchase.store'

export function usePurchase() {
  const isSubmitting = usePurchaseStore((state) => state.isSubmitting)
  const isLoading = usePurchaseStore((state) => state.isLoading)
  const purchases = usePurchaseStore((state) => state.purchases)
  const error = usePurchaseStore((state) => state.error)

  const fetchPurchasePersons = usePurchaseStore(
    (state) => state.fetchPurchasePersons,
  )
  const createPurchasePerson = usePurchaseStore(
    (state) => state.createPurchasePerson,
  )
  const updatePurchasePerson = usePurchaseStore(
    (state) => state.updatePurchasePerson,
  )
  const deletePurchasePerson = usePurchaseStore(
    (state) => state.deletePurchasePerson,
  )
  const clearError = usePurchaseStore((state) => state.clearError)

  return {
    isSubmitting,
    isLoading,
    purchases,
    error,
    fetchPurchasePersons,
    createPurchasePerson,
    updatePurchasePerson,
    deletePurchasePerson,
    clearError,
  }
}
